import { Download01Icon } from '@/components/icons/Download01Icon';
import { useFeedback } from '@/components/notifications/Feedback/useFeedback';
import { MenuItem } from '@/components/poppers/MenuPopper/MenuItem';
import { useReportError } from '@/hooks/useReportError';
import { $downloadStreamedFile } from '@/modules/files/utils/fileUtils';

import { useDownloadFiduciaryReportV2Mutation } from './graphql/DownloadFiduciaryReport.generated';

interface DownloadFiduciaryReportMenuItemProps {
  householdId: string;
  onClick?: () => void;
}

export function DownloadFiduciaryReportMenuItem({
  householdId,
  onClick,
}: DownloadFiduciaryReportMenuItemProps) {
  const { showFeedback } = useFeedback();
  const { reportError } = useReportError();

  const [downloadFiduciaryReport, { loading }] =
    useDownloadFiduciaryReportV2Mutation({
      onError: (error: Error) => {
        showFeedback('Failed to download fiduciary report');
        reportError('Could not download fiduciary report', error);
      },
      onCompleted: async (data) => {
        const token = data?.exportFiduciaryReportV2?.token;
        if (token) {
          try {
            await $downloadStreamedFile(`/api/download/file?token=${token}`);
          } catch (err) {
            showFeedback('Failed to generate excel file. Please try again.');
          }
        } else {
          showFeedback('Failed to generate excel file. Please try again.');
        }
      },
    });

  const handleClick = () => {
    void downloadFiduciaryReport({ variables: { householdID: householdId } });
    onClick?.();
  };

  return (
    <MenuItem
      onClick={handleClick}
      icon={<Download01Icon size={16} />}
      label="Download fiduciary report"
      loading={loading}
    />
  );
}
